export default __webpack_public_path__ + "static/media/login_side_image_patient.20b03bc1.jpg";